export default __webpack_public_path__ + "static/media/copy-link.b1a4aa93.svg";